import React from 'react';
import PropTypes from 'prop-types';
import { SENSOR_STATUS_LABELS, SENSOR_TYPE_LABELS } from '../../types/lawnTypes';

/**
 * Table view of the same sensors shown as pins.
 *
 * Easier to scan than the map, and it matches how the rows arrive from SQLite,
 * which makes it a useful check that the pin view and the data agree.
 */

const formatTimestamp = (value) => {
  if (!value) return 'Never';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export default function SensorListWidget({ sensors, selectedSensorId, onSelectSensor }) {
  if (!sensors || sensors.length === 0) {
    return (
      <p className="lawn-widget-muted">
        No sensors yet. Place one on the property view to populate this list.
      </p>
    );
  }

  return (
    <div className="lawn-table-wrapper">
      <table className="lawn-table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Type</th>
            <th scope="col">Status</th>
            <th scope="col">Moisture</th>
            <th scope="col">Battery</th>
            <th scope="col">Last reading</th>
          </tr>
        </thead>
        <tbody>
          {sensors.map((sensor) => (
            <tr
              key={sensor.id}
              className={sensor.id === selectedSensorId ? 'lawn-table-row-selected' : undefined}
              onClick={() => onSelectSensor(sensor)}
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onSelectSensor(sensor);
                }
              }}
            >
              <td>{sensor.name}</td>
              <td>{SENSOR_TYPE_LABELS[sensor.type] || sensor.type}</td>
              <td>
                <span className={`lawn-table-status lawn-table-status-${sensor.status}`}>
                  {SENSOR_STATUS_LABELS[sensor.status] || sensor.status}
                </span>
              </td>
              <td>{sensor.moisturePct === null ? '—' : `${sensor.moisturePct}%`}</td>
              <td>{sensor.batteryPct}%</td>
              <td>{formatTimestamp(sensor.lastReadingAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

SensorListWidget.propTypes = {
  sensors: PropTypes.array,
  selectedSensorId: PropTypes.string,
  onSelectSensor: PropTypes.func.isRequired,
};

SensorListWidget.defaultProps = {
  sensors: [],
  selectedSensorId: null,
};
